import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { FormikProps } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormProfiles } from 'system/pages/profiles/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersProfilesProps {
  filterProfiles: FormikProps<FiltersFormProfiles>;
}

const FiltersProfile = ({ filterProfiles }: FiltersProfilesProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-circulationarea-content"
        id="panel-circulationarea-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterProfiles.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2}>
              <PmiTextField
                aria-label="Codice"
                label="Codice"
                id="id"
                name="id"
                fullWidth
                type="text"
                variant="outlined"
                value={filterProfiles.values.id}
                onChange={filterProfiles.handleChange}
                error={filterProfiles.touched.id && Boolean(filterProfiles.errors.id)}
                helperText={filterProfiles.errors.id}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <PmiTextField
                aria-label="Descrizione"
                label="Descrizione"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterProfiles.values.description}
                onChange={filterProfiles.handleChange}
                error={
                  filterProfiles.touched.description && Boolean(filterProfiles.errors.description)
                }
                helperText={filterProfiles.errors.description}
              />
            </Grid>
            <Grid item xs>
              <PmiButton variant="contained" color="secondary" type="submit">
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersProfile.displayName = 'Filters Circulation Area component';

export default FiltersProfile;
